import { Component, OnInit } from '@angular/core';
import { Data } from '@angular/router';
import { Select } from '@ngxs/store';
import { AccountTitleService } from '@platform-frontend/account';
import { IconName } from '@platform-frontend/ui-tools';
import { SimpleRouterState, TranslationId } from '@platform-frontend/util';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'yat-simple-header',
  templateUrl: './simple-header.component.html',
  styleUrls: ['./simple-header.component.scss']
})
export class SimpleHeaderComponent implements OnInit {
  constructor(private accountTitleService: AccountTitleService) {}

  @Select(SimpleRouterState.data)
  routeData$: Observable<Data>;

  title$: Observable<TranslationId | undefined>;
  titleIcon$: Observable<IconName | null>;
  titleIconClass$: Observable<string | null>;

  ngOnInit(): void {
    this.title$ = this.accountTitleService.getTitle();

    this.titleIcon$ = this.routeData$.pipe(map(data => data.titleIcon || null));

    this.titleIconClass$ = this.routeData$.pipe(map(data => data.titleIconClass || null));
  }
}
